app.service('loading', function (console, html, broker) {
	var $self;

	function start() {
		if ($self && $self.length) {
			html.add('show-loading');
			console.log('LOADING start');
		} else {
			init();
			start();
		}
	}
	function stop() {
		html.remove('show-loading');
		console.log('LOADING stop');
	}
	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			$(window).on('pagehide', function () {
				stop();
			});
			$self = $('<div id="loading"/>').appendTo($('body')); //TODO zastanowić się czy aby tego nie zmienić na wzór desktpu
		}
	}
	function redirect(params) {
		if (typeof params == 'object' && params.soft) {
			broker.trigger('SOFT_REDIRECT', params.href);
		} else {
			let href = typeof params == 'object' ? params.href : params;
			console.log('LOADING redirect', href);
			start();
			//remodal blokuje javascript jesli jego animacja się nie zakończy
			requestAnimationFrame(function () {
				document.location.href = href;
			});
		}
	}
	function reload(params) {
		if (params && params.soft) {
			broker.trigger('SOFT_RELOAD');
		} else {
			console.log('LOADING reload');
			start();
			document.location.reload(true);
		}
	}

	return {
		start,
		stop,
		redirect,
		reload
	};
});
